// Persistence adapter: if Web Storage is unavailable (blocked, private mode, kiosk policy) install an
// in-memory Storage so every existing `localStorage.*` call keeps working for the session.
// Loaded first from index.js. Personal persistence is unchanged when storage works.
function memoryStorage() {
  const m = new Map();
  return {
    get length() { return m.size; },
    key: (i) => [...m.keys()][i] ?? null,
    getItem: (k) => (m.has(String(k)) ? m.get(String(k)) : null),
    setItem: (k, v) => { m.set(String(k), String(v)); },
    removeItem: (k) => { m.delete(String(k)); },
    clear: () => { m.clear(); },
    __memory: true,
  };
}

function ensure(name) {
  let ok = false;
  try { const s = window[name]; s.setItem("__mwq_probe", "1"); s.removeItem("__mwq_probe"); ok = true; } catch { ok = false; }
  if (ok) return false;
  try { Object.defineProperty(window, name, { value: memoryStorage(), configurable: true, writable: false }); return true; } catch { return false; }
}

export const STORAGE_FALLBACK = { localStorage: ensure("localStorage"), sessionStorage: ensure("sessionStorage") };
export const storageIsMemory = () => !!STORAGE_FALLBACK.localStorage;
